import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class PoliceIncidentsDisplay extends Component {
    render() {
        const {incidents} = this.props;

        return (
            <div className="d-flex flex-column w-100">
                {
                    incidents.map((incident, i) => {
                        const date = moment(incident.received);
                        return (
                            <div key={i} className="d-flex flex-column mt-2 mb-2" style={{border: '2px solid grey', borderRadius: '15px', padding: '1rem'}}>
                                <div className="d-flex flex-row w-100 justify-content-between">
                                    <h4 className="text-primary"><strong>{incident.raw_address}</strong></h4>
                                    <h5>
                                        <strong>
                                            <small>Incident ID: {incident.incident_id}</small>
                                        </strong>
                                    </h5>
                                    <h5>
                                        <strong>
                                            <small>Received: {date.format("MM/DD/YYYY, hh:mm a")}</small>
                                        </strong>
                                    </h5>
                                </div>
                                <div className="d-flex flex-row w-100 justify-content-start">
                                    <h4>Incident Type: {incident.incident_type}</h4>
                                    <h4 style={{marginLeft: "4rem"}}>Code: {incident.code}</h4>
                                </div>
                                <div className="d-flex flex-row w-100 justify-content-between">
                                    <h4>
                                        <small>Comments: {incident.comments}</small>
                                    </h4>
                                </div>
                                <div className="d-flex flex-row w-100 justify-content-between">
                                    <h4>
                                        <small>Description: {incident.description}</small>
                                    </h4>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

PoliceIncidentsDisplay.propTypes = {
    incidents: PropTypes.array.isRequired,
};

export default PoliceIncidentsDisplay;


// WEBPACK FOOTER //
// ./src/containers/owner/applications/PoliceIncidentsDisplay.js